<template>
  <Modal
      v-if="showConfirmationModal"
      :config="{...modalConfig.confirmDeposit, title:modalTitle}"
      @btn1Action="config.breakageType !== 'full' ? routeToAccountDetails(config) : ''"
      @btn2Action="routeToDashboard()">
      <span slot="modalContent" data-qa="confirmdeposit-span-daqkk6">
        <span slot='modalContent' class='font-weight-medium'
          style="display: block;"
          v-if="config.action === 'amend'" data-qa="confirmdeposit-span-nv92sn">
          {{ $t("termDepositActions.breakDeposit.subtitle") }}
        </span>
        <div class="text-center pa-10" data-qa="confirmdeposit-div-mv8ppr">
          <v-flex v-if="config.action === 'break'" data-qa="confirmdeposit-flex-attwnl">
            <v-flex class="text-center subtitle-1 mx-4" data-qa="confirmdeposit-flex-3kc7n">
              {{ $t("termDepositActions.breakDeposit.breakageSuccessMsg1") }}
              <font :color="$formatter.currency.isNegativeBalance(config.breakageAmount) ? errorColor : ''">
                {{ config.breakageAmount }}
              </font>

              {{ config.payAwayAccount }}.
            </v-flex>
            <v-flex v-if="config.breakageType === 'partial'" data-qa="confirmdeposit-flex-89q3ah">
              <v-row class="mt-2 px-3" data-qa="confirmdeposit-row-gyf7z9">
                <v-flex class="text-left mx-10" xs12 sm12 md12 lg12 xl12 data-qa="confirmdeposit-flex-aala8a">
                  <v-layout class="py-3" row wrap data-qa="confirmdeposit-layout-fzkgaa">
                    <v-flex xs6 sm6 md6 lg6 xl5 data-qa="confirmdeposit-flex-p9gzvb">
                      <span class="caption font-weight-bold text-uppercase" data-qa="confirmdeposit-span-x6ysoj">
                        {{ $t("termDepositActions.breakDeposit.remainingAmount") }}
                      </span>
                      <br data-qa="confirmdeposit-br-4lrgif"  />
                      <font :color="$formatter.currency.isNegativeBalance(config.remainingAmount) ? errorColor : ''">
                        {{ config.remainingAmount }}
                      </font>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl5 data-qa="confirmdeposit-flex-n7r4ng">
                      <span class="caption font-weight-bold text-uppercase" data-qa="confirmdeposit-span-7lkix">
                        {{ $t("termDepositActions.breakDeposit.rateOfInterest") }}
                      </span>
                      <br data-qa="confirmdeposit-br-ecrlrf"  />
                      {{ config.interestRate }} %
                    </v-flex>
                  </v-layout>
                  <v-layout class="py-3" row wrap data-qa="confirmdeposit-layout-ne4faw">
                    <v-flex xs6 sm6 md6 lg6 xl5 data-qa="confirmdeposit-flex-q3g54">
                      <span class="caption font-weight-bold text-uppercase" data-qa="confirmdeposit-span-xhz46">
                        {{ $t("termDepositActions.breakDeposit.maturityAmount") }}
                      </span>
                      <br data-qa="confirmdeposit-br-4e8z7m"  />
                      <font :color="$formatter.currency.isNegativeBalance(config.maturityAmount) ? errorColor : ''">
                        {{ config.maturityAmount }}
                      </font>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl5 data-qa="confirmdeposit-flex-76ev1l">
                      <span class="caption font-weight-bold text-uppercase" data-qa="confirmdeposit-span-3k4328">
                        {{ $t("termDepositActions.breakDeposit.interestAtMaturity") }}
                      </span>
                      <br data-qa="confirmdeposit-br-ebfi7q"  />
                      <font :color="$formatter.currency.isNegativeBalance(config.interestAtMaturity) ? errorColor : ''">
                        {{ config.interestAtMaturity }}
                      </font>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-row>
            </v-flex>
          </v-flex>
          <v-row data-qa="confirmdeposit-row-jy5yqk">
          </v-row>
        </div>
      </span>
    </Modal>
</template>

<script>
import _ from 'lodash'
import store from '@/core/store'
import event from '@/util/event'
import preload from '@/util/preload'

export default {
  name: 'ConfirmDeposit',
  props: {
    config: Object
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      showConfirmationModal: this.config.showConfimModal,
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      modalConfig: {
        confirmDeposit: {
          enabled: true,
          persistent: true,
          btn1Label: this.$t('termDepositActions.breakDeposit.viewAccDetailsBtnLabel'),
          btn2Label: this.$t('termDepositActions.breakDeposit.goToDashboardBtnLabel'),
          width: 500
        }
      }
    }
  },
  created () {
    event.$emit('amendDepositDataSanity', false)
    event.$emit('closeDepositDataSanity', false)
  },
  computed: {
    modalTitle () {
      if (this.config.action === 'amend') {
        return `Hey ${this.config.username || this.getUserName()}, 
        ${this.$t(`termDepositActions.amendDeposit.${this.config.amendedOption}`)}
        ${this.$t('termDepositActions.amendDeposit.amendSuccessMsg')}`
      } else return ''
    }
  },
  methods: {
    getBreakageType (breakageType) {
      return _.startCase(this.config.breakageType)
    },
    routeToDashboard () {
      setTimeout(() => {
        this.$router.push({ path: '/home' })
      }, 600)
    },
    async routeToAccountDetails (props) {
      this.config.tdDetails.accountId = this.config.tdDetails.fixedDepositAccountId
      const actionList = await preload.getTDActionList(_.upperCase(this.config.tdDetails.status), this.$formatter.formatDate(this.config.tdDetails.startDate))
      this.config.tdDetails.actionList = actionList && actionList.length ? actionList : ''
      const item = this.config.tdDetails
      this.$router.push({ name: 'AccountDetails', params: { product: item, balance: item.currentBalance.value, accountId: item.fixedDepositAccountId, accountType: 'TD' } })
      // TODO this.$router.push({ name: 'AccountDetails', params: { product: item, balance: item.balance, accountId: item.accountId, accountName: item.customerName, accountType: item.accountType } })
    },
    getUserName () {
      const data = store.getters['profileStore/profileData'].customerDetails
      if (data) {
        return data.fullName || 'Roger Moore'
      }
    }
  }
}
</script>
